import { render, staticRenderFns } from "./ImportWhite.vue?vue&type=template&id=62fc184f&scoped=true&"
import script from "./ImportWhite.vue?vue&type=script&lang=js&"
export * from "./ImportWhite.vue?vue&type=script&lang=js&"
import style0 from "./ImportWhite.vue?vue&type=style&index=0&id=62fc184f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc184f",
  null
  
)

export default component.exports